import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { GetTipsAndTricks } from "../../Config/API/tipsAndTricks";
import { isLoading } from "../../Store/Features/ProfileSlice";
import useVariables from "./useVariables";

export function useFetchAllTipsAndTricks(role, filters) {
  const [fetchloading, setfetchloading] = useState(true);
  const [POSTS, setPOSTS] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const loading = useSelector(isLoading);
  const { viewer } = useVariables();
  const [fetchTime, setFetchTime] = useState(500); // Default value of 500ms

  const GetAllPosts = async () => {
    try {
      const startTime = performance.now(); // Start timing

      const res = await GetTipsAndTricks(filters);

      const endTime = performance.now(); // End timing
      setFetchTime(endTime - startTime); // Set fetch time

      if (!res.ok) {
        throw new Error(res.statusText + " - " + res.url);
      }
      const data = await res.json();
      setfetchloading(false);
      if (data.type !== "success") {
        Swal.fire({
          icon: "error",
          title: data?.result
        });
      } else {
        setPOSTS(data?.result || []);
        setTotalPages(data?.metaData?.totalPages || 1);
      }
      setfetchloading(false);
    } catch (e) {
      console.log(e.name === "AbortError" ? "FetchPostsRequest canceled" : e.message);
      setfetchloading(false);
    }
  };
  useEffect(() => {
    const controller = new AbortController();
    if (viewer?.id && !loading) {
      GetAllPosts(controller);
    }
    return () => {
      setfetchloading(null);
      setPOSTS([]);
    };
  }, [page]);

  return {
    fetchloading,
    POSTS,
    setPOSTS,
    setPage,
    totalPages,
    page,
    fetchTime,
    GetAllPosts
  };
}
